export const RouteDefine = {
    resetPassword: '/reset-password',
    forgotPassword: '/forgot-password',

    setup: '/setup',
    login: '/login',
    adminLogin: '/admin-login',
    order: '/orders',
    admin: '/admin',
    settings: '/settings',
    settingsBusiness: '/settings/business',
    settingsEconomic: '/settings/economic',
    settingsStripe: '/settings/stripe',
    settingsSchedule: '/settings/schedule',
    settingsProductGroup: '/settings/product-group',
    help: '/help',
    customer: '/customers',
    dashboard: '/dashboard',
    integrate: '/integrate',
    integrateNew: '/integrate/new',
    integrateDetail: '/integrate/:id',
    shipment: '/shipment',
    document: '/document',
    log: '/log',

    userUpdate: '/user',
    userDetail: '/user/business-detail',
    /** @deprecated Legacy URL — redirects to settingsBusiness */
    business: '/business',
    businessUpdate: '/business-update',
    mobilePay:'/mobile-pay',
    /** @deprecated Legacy URL — redirects to settingsEconomic */
    economic: '/economic',

    confirm: '/confirm',
    register: '/register',
    config: '/config',
    shippingInformation:'/shipping-information',


    invoice: '/invoice',
    payment: '/payment',
    payout: '/payout',
    subscription: '/subscription',
    refund: '/refund',

    /** @deprecated Legacy URL — redirects to settingsStripe */
    stripe: '/stripe',

    forbidden: '/403',
    notFound: '/404',
}
